import styled from "styled-components";
import { colors } from "../../../utils";

export const CenterWrapper = styled.div`
  background-color: ${colors.white};
  padding: 2vw;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledHeading = styled.div`
    font-size: 16px;
    font-weight: 500;
    color: "#123051;
    line-height: 20px;
    font-family: "DM Sans";
`

export const LabelContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`